import './LogoBox.scss'
import React from 'react'

const LogoBox = () => {
    return (
        <div className='logo-box'>
            <h3>WeatherApp</h3>
            <h4>Only Actual Data</h4>
        </div>
    )
}

export default LogoBox
